import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';
import useGiphyObserver from 'components/Giphy/useGiphyObserver';
import { chatFontSettings } from 'utils/helpers';

import Message from './Message';
import styles from './ChatMessageTypes.css';
import Gif from './components/Gif';


const CoachMessage = (props) => {
  const {
    chatSettings,
    embedProfileV2,
    isBroadcasterChat,
    isDesktop,
    isTranslated,
    msg,
    openContextualChatModal,
    showOriginalLanguage,
  } = props;

  const [giphyObserver, isIntersecting] = useGiphyObserver();

  const wrapperClasses = classNames({
    [styles.coachMsgWrapper]: true,
    [styles.gifsWrapper]: msg.isGif,
  });
  const wrapperDesktopClasses = classNames({
    [styles.coachDesktopMsgWrapper]: true,
    [styles.gifsWrapper]: msg.isGif,
  });
  const msgContentClasses = classNames({
    [styles.msgContent]: true,
    [styles.gifBackground]: msg.isGif,
  });

  const handleOpenContextualChat = useCallback(() => {
    if (!embedProfileV2) {
      openContextualChatModal(msg.senderOriginalUsername);
    }
  }, [
    embedProfileV2,
    openContextualChatModal,
    msg.senderOriginalUsername,
  ]);

  return (
    <Fragment>
      <Message.ContextualMenuOpener>
        {(openMenu) => (
          <div ref={giphyObserver} className={styles.coachMsg}>
            {isDesktop && (
              <>
                <Message.UserAvatar
                  hideRecentSpendingTierIndicator={true}
                  isBroadcasterChat={isBroadcasterChat}
                  onClick={openMenu}
                />
                <div className={wrapperDesktopClasses}>
                  <Message.GoldUserView>
                    <Message.GoldIcon />
                  </Message.GoldUserView>
                  <Message.FanclubSubscribedView>
                    <Message.FanclubUserIcon />
                  </Message.FanclubSubscribedView>
                  <span>
                    <span
                      className={styles.msgSender}
                      role="presentation"
                      style={chatFontSettings(isDesktop, chatSettings)}
                      onClick={openMenu}
                    >
                      {msg.senderOriginalUsername}
                      <span className={styles.coach}>
                        {translate('v2profile.chat.coach')}
                      </span>
                    </span>
                  </span>
                  {isTranslated && (
                    <>
                      <span
                        className={msgContentClasses}
                        style={chatFontSettings(isDesktop, chatSettings)}
                      >
                        <Gif
                          alt={msg.translatedMessage}
                          isIntersecting={isIntersecting}
                          msg={msg}
                        />
                      </span>
                      {showOriginalLanguage && !msg.isGif && (
                        <div className={styles.italicOriginalMsg}>
                          <span
                            className={styles.msgContent}
                            style={chatFontSettings(isDesktop, chatSettings)}
                          >
                            {msg.message}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                  {!isTranslated && (
                    <span
                      className={msgContentClasses}
                      style={chatFontSettings(isDesktop, chatSettings)}
                    >
                      <Gif
                        alt={msg.message}
                        isIntersecting={isIntersecting}
                        msg={msg}
                      />
                    </span>
                  )}
                </div>
              </>
            )}

            {!isDesktop && (
              <div className={wrapperClasses}>
                <Message.GoldUserView>
                  <Message.GoldIcon />
                </Message.GoldUserView>
                <Message.FanclubSubscribedView>
                  <Message.FanclubUserIcon />
                </Message.FanclubSubscribedView>
                <span
                  className={styles.msgSender}
                  role="presentation"
                  style={chatFontSettings(isDesktop, chatSettings)}
                  onClick={handleOpenContextualChat}
                >
                  {msg.senderOriginalUsername}
                  <span className={styles.coach}>
                    {translate('v2profile.chat.coach')}
                  </span>:
                </span>
                {isTranslated && (
                  <>
                    <span
                      className={msgContentClasses}
                      style={chatFontSettings(isDesktop, chatSettings)}
                    >
                      <Gif
                        alt={msg.translatedMessage}
                        isIntersecting={isIntersecting}
                        msg={msg}
                      />
                    </span>
                    {showOriginalLanguage && !msg.isGif && (
                      <div className={styles.italicOriginalMsg}>
                        <span
                          className={styles.msgContent}
                          style={chatFontSettings(isDesktop, chatSettings)}
                        >
                          {msg.message}
                        </span>
                      </div>
                    )}
                  </>
                )}
                {!isTranslated && (
                  <span
                    className={msgContentClasses}
                    style={chatFontSettings(isDesktop, chatSettings)}
                  >
                    <Gif
                      alt={msg.message}
                      isIntersecting={isIntersecting}
                      msg={msg}
                    />
                  </span>
                )}
              </div>
            )}
            <Message.BroadcasterView>
              <Message.MenuIcon openMenu={openMenu} />
            </Message.BroadcasterView>
          </div>
        )}
      </Message.ContextualMenuOpener>
      <Message.BroadcasterView>
        <Message.NotesIcon />
      </Message.BroadcasterView>
    </Fragment>
  );
};

CoachMessage.propTypes = {
  chatSettings: PropTypes.object,
  embedProfileV2: PropTypes.bool,
  isBroadcasterChat: PropTypes.bool,
  isDesktop: PropTypes.bool,
  isTranslated: PropTypes.bool,
  msg: PropTypes.object,
  openContextualChatModal: PropTypes.func,
  showOriginalLanguage: PropTypes.bool,
};

CoachMessage.defaultProps = {
  chatSettings: {},
  embedProfileV2: false,
  isBroadcasterChat: false,
  isDesktop: false,
  isTranslated: false,
  msg: {},
  openContextualChatModal: null,
  showOriginalLanguage: false,
};

export default CoachMessage;
